module.exports = __webpack_public_path__ + "img/Rogue-orc-f-70.32aab404.gif";